__turbopack_context__.v({
  "addPill": "InvestmentDetailsSection-module-scss-module__sN9A7q__addPill",
  "badgesWrapper": "InvestmentDetailsSection-module-scss-module__sN9A7q__badgesWrapper",
  "keywordsLabel": "InvestmentDetailsSection-module-scss-module__sN9A7q__keywordsLabel",
  "keywordsWrapper": "InvestmentDetailsSection-module-scss-module__sN9A7q__keywordsWrapper",
  "section": "InvestmentDetailsSection-module-scss-module__sN9A7q__section",
});
